import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
// jwt
import { JwtModule } from '@auth0/angular-jwt';
import { UserWalletComponent } from '@customers/user-profile/user-wallet/user-wallet.component';
import { CartCustomerService } from '@parts-catalog/services/cart.customer.service';
import { WatchStorageService } from '@parts-catalog/services/watchstorage.service';
import { AnonymousGuardCustomerService } from '@reusable/services/auth/AnonymousGuard.service';
import { AuthService } from '@reusable/services/auth/auth.service';
import { BrandService } from '@reusable/services/brand/brand.service';
import { ContentService } from '@reusable/services/common/content.service';
// pipes
// services
import { GetTokenNow } from '@reusable/services/globals';
import { GoogleAnalytics } from '@reusable/services/google-analytics.service';
import { S3Uploader } from '@reusable/services/helpers/uploader.service';
import { MessagingService } from '@reusable/services/messaging.service';
import { NavigationService } from '@reusable/services/navigation/navigation.service';
import { RoutePartsService } from '@reusable/services/route-parts/route-parts.service';
import { SharedService } from '@reusable/services/shared.service';
import { UsersService } from '@reusable/services/users/users.service';
// modules
import { SharedModule } from '@reusable/shared/shared.module';
import { FIREBASE_CONFIG } from '@src/firebase.config';
import { LookupService } from '@team/services/lookup.service';
import { DateValueAccessorModule } from 'angular-date-value-accessor';
import { initializeApp } from 'firebase/app';
import { CookieService } from 'ngx-cookie-service';
// app component
import { AppComponent } from './app.component';
import { ControlBarComponent } from './common/control-bar/control-bar.component';
import { FooterComponent } from './common/footer/footer.component';
import { HeaderComponent } from './common/header/header.component';
import { NotificationWidgetComponent } from './common/notification-widget/notification-widget.component';
import { ProfileWidgetComponent } from './common/profile-widget/profile-widget.component';
import { CustomersHomeComponent } from './customers-home/customers-home.component';
// routes configration
import { customersRoutes } from './customers.routes';
import { MyCarsFormComponent } from './my-cars-form/my-cars-form.component';
import { MyCarsComponent } from './my-cars/my-cars.component';
import { NotifcationsComponent } from './notifications/notifcations/notifcations.component';
import { NotificationCustomerService } from './services/notification.customer.service';
import { PackagesCustomerService } from './services/packages.customer.service';
import { ProfileCustomerService } from './services/profile.customer.service';
import { SharedCustomerService } from './services/shared.customer.service';
import { WalletCustomerService } from './services/wallet.customer.service';

// config firebase

initializeApp(FIREBASE_CONFIG);

// Token tokenGetter
export function tokenGetter() {
  return localStorage.getItem('accessToken');
}

// Zendesk
window['zESettings'] = {
  webWidget: {
    launcher: {
      badge: {
        label: {
          '*': 'مركز الدعم و المساعدة'
        },
        layout: 'text_only'
      }
    },
    position: { horizontal: 'left', vertical: 'bottom' },
    chat: {
      suppress: true
    },
    helpCenter: {
      searchPlaceholder: {
        '*': 'ابحث'
      },
      title: {
        '*': 'مركز المساعدة'
      },
      messageButton: { '*': 'اطلب مساعدة' }
    },
    contactOptions: {
      enabled: true
    },
    color: { theme: '#251E44' }
  }
};

@NgModule({ declarations: [
  CustomersHomeComponent,
  HeaderComponent,
  FooterComponent,
  ProfileWidgetComponent,
  NotificationWidgetComponent,
  ControlBarComponent,
  NotifcationsComponent,
  MyCarsComponent,
  MyCarsFormComponent,
  UserWalletComponent,
  AppComponent
],
bootstrap: [AppComponent], imports: [CommonModule,
  BrowserModule,
  BrowserAnimationsModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule.forRoot(customersRoutes, {
    scrollPositionRestoration: 'top',
    useHash: false
  }),
  SharedModule,
  DateValueAccessorModule,
  JwtModule.forRoot({
    config: {
      tokenGetter,
      allowedDomains: [],
      disallowedRoutes: []
    }
  })], providers: [
  ProfileCustomerService,
  PackagesCustomerService,
  NotificationCustomerService,
  SharedCustomerService,
  WalletCustomerService,
  GetTokenNow,
  BrandService,
  AuthService,
  RoutePartsService,
  NavigationService,
  SharedService,
  S3Uploader,
  ContentService,
  GoogleAnalytics,
  MessagingService,
  UsersService,
  LookupService,
  WatchStorageService,
  CartCustomerService,
  AnonymousGuardCustomerService,
  CookieService,
  provideHttpClient(withInterceptorsFromDi())
] })
export class CustomersModule { }